  export const fieldToSectionMap = {
    // marketplace
    marketplace: "marketplace",

    // buyingCriteria
    minbsr: "buyingCriteria",
    maxbsr: "buyingCriteria",
    minProfit: "buyingCriteria",
    minroi: "buyingCriteria",
  
    // additionalCosts
    prepfee: "additionalCosts",
    miscfee: "additionalCosts",
    miscfeepercent: "additionalCosts",
    inbound_shipping: "additionalCosts",
    use_peak_storage_fees: "additionalCosts",
  
    // defaultValues
    ranksprices_timeframe: "defaultValues",
    bb_analysis_timeframe: "defaultValues",
    charts_timeframe: "defaultValues",
    bb_analysis_sortorder: "defaultValues",
    fbm_cost: "defaultValues",
    storage_time: "defaultValues",
    local_fullfillment: "defaultValues",
    europian_fullfillment: "defaultValues",
    custom_roi: "defaultValues",
    fba_inbound_placement_service: "defaultValues",
  
    // miscellaneous
    keepa_on_results: "miscellaneous",
    store_geo_location: "miscellaneous",
  
    // quickInfo
    show_profit: "quickInfo",
    show_profit_margin: "quickInfo",
    show_roi: "quickInfo",
    show_breakeven: "quickInfo",
    show_offer_summary: "quickInfo",
  
    // panels
    overview: "panels",
    ranks_and_prices: "panels",
    alerts: "panels",
    charts: "panels",
    profit_calculator: "panels",
    variations: "panels",
    dimensions: "panels",
    seller_central: "panels",
    offers: "panels",
    lookup_details: "panels",
    roi: "panels",
    buybox_analysis: "panels",
  };